module.exports = __webpack_public_path__ + "static/mybridge-33a66b7dfd956c3745fc60a02a5175f8.png";